import * as swcHelpers from '@swc/helpers';
import ReactGA from 'react-ga';
import { QueryString, StringGuard } from '@grandvisionhq/utils';

const initGA = (trackerID, options)=>{
    const { analyticsId  } = QueryString.parse(window.location.search.substring(1));
    const GAOptions = swcHelpers.objectSpread({}, options, analyticsId ? {
        gaOptions: {
            clientId: StringGuard.guard('analyticsId', analyticsId)
        }
    } : {});
    ReactGA.initialize(trackerID, GAOptions);
};
const logError = (scope, message)=>{
    console.error(`[${scope}] ${message}`);
};
/**
 * when using adblocking the callback will never be hit. Creating an order will be then blocked.
 * Check if google tag manager is loaded else resolve.
 */ const getAnalyticsId = ()=>{
    return new Promise((resolve)=>{
        const { ga  } = window;
        let timeoutFlag = false;
        const gaTimeout = setTimeout(()=>{
            logError('getAnalyticsId', 'ReactGa not loaded. Hit timeout.');
            timeoutFlag = true;
            resolve();
        }, 200);
        ReactGA.ga((tracker)=>{
            if (timeoutFlag) {
                return;
            }
            clearTimeout(gaTimeout);
            if (!tracker) {
                logError('getAnalyticsId', 'Analytics not initialized');
                resolve();
            }
            const clientId = tracker.get('clientId');
            if (clientId) {
                resolve(clientId);
            } else {
                logError('getAnalyticsId', 'No client id received from ReactGA tracker.');
                resolve();
            }
        });
        if (!ga || !ga.loaded) {
            clearTimeout(gaTimeout);
            logError('getAnalyticsId', 'ReactGa not loaded.');
            resolve();
        }
    });
};
const logPageView = (pathName)=>{
    if (pathName) {
        ReactGA.set({
            page: pathName
        });
        ReactGA.pageview(pathName);
    } else {
        let location = window.location.pathname;
        const href = window.location.href.split('?')[1];
        if (href) {
            location = location + '?' + href;
        }
        ReactGA.set({
            page: location
        });
        ReactGA.pageview(location);
    }
};
const GoogleAnalytics = {
    initGA,
    getAnalyticsId,
    logPageView
};

export { GoogleAnalytics as default };
//# sourceMappingURL=GoogleAnalytics.js.map
